module.exports = __webpack_public_path__ + "img/img90.33865289.svg";